export const DEFAULT_TIME_FORMAT = 'h:mm a';
//# sourceMappingURL=constants.js.map